/**
 * Effettua la chiamata al servizio per ottenere il catalogo delle molecole.
 * Legge il body con text(), poi prova il JSON: gestisce anche 500 con body vuoto.
 */
export async function queryMolecules(queryParams) {
    const response = await fetch("https://molecules.softmining.it/ws.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(queryParams),
    });

    const text = await response.text();
    let data;
    try {
        data = text ? JSON.parse(text) : {};
    } catch {
        throw new Error(`Server returned unparseable response (status ${response.status})`);
    }

    if (!response.ok) {
        // usa reason o statusText
        const msg = data.reason || data.message || response.statusText;
        throw new Error(`HTTP ${response.status}: ${msg}`);
    }

    console.log(data);
    return data;
}

/**
 * Inoltra una richiesta RDKit per generare le immagini PNG delle molecole.
 */
export async function enqueueRdkitRequest(smilesArray, IDD) {
    const response = await fetch("https://molecules.softmining.it/rdkit.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            serviceName: "ENQUEUE_RDKIT_REQUEST",
            IDD: "IDD",
            Token: "000111",
            Smiles: smilesArray,
        }),
    });

    const data = await response.json();
    if (!response.ok) {
        const msg = data.reason || response.statusText;
        throw new Error(`HTTP ${response.status}: ${msg}`);
    }
    return data;
}

/**
 * Verifica lo stato di un job RDKit finch� non viene completato.
 */
export async function getRdkitRequestStatus(jid) {
    const response = await fetch("https://molecules.softmining.it/rdkit.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            serviceName: "RDKIT_REQUEST_STATUS",
            IDD: "6750add707a1d9066ce54ec6",
            Token: "000111",
            JID: jid,
        }),
    });

    const data = await response.json();
    if (!response.ok) {
        const msg = data.reason || response.statusText;
        throw new Error(`HTTP ${response.status}: ${msg}`);
    }
    return data;
}
